/** Browser storage key of the demo's viewer session for node visibility (one per browser, for every scene). */
export const VISIBILITY_SESSION_STORAGE_KEY: string = 'hyperscene.demo.visibilitySessionId';

const ID_PATTERN: RegExp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * The browser's visibility session id: Hide, Isolate and Show all of the demo apply to this id only, so they stay
 * with this browser across page loads and do not change the scene for others. Created on first use.
 */
export function loadVisibilitySessionId(storage: Storage | null = browserStorage()): string {
  let stored: string | null = null;
  try {
    stored = storage?.getItem(VISIBILITY_SESSION_STORAGE_KEY) ?? null;
  } catch {
    // Storage is blocked; a session for this page load still works.
  }
  return stored !== null && ID_PATTERN.test(stored) ? stored : createVisibilitySessionId(storage);
}

/** Starts a new visibility session for this browser, replacing the stored one; returns its id. */
export function createVisibilitySessionId(storage: Storage | null = browserStorage()): string {
  const id: string = newUuid();
  try {
    storage?.setItem(VISIBILITY_SESSION_STORAGE_KEY, id);
  } catch {
    // Storage is blocked; the id lives until the page is reloaded.
  }
  return id;
}

function newUuid(): string {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }
  const bytes: Uint8Array = new Uint8Array(16);
  for (let index: number = 0; index < bytes.length; index++) {
    bytes[index] = Math.floor(Math.random() * 256);
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex: string = Array.from(bytes, (byte: number) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

function browserStorage(): Storage | null {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}
